import type { StoryElement } from '../types';

export function storyPermalinkId(story: Pick<StoryElement, 'id' | 'topic_id'>): string {
  return story.topic_id || story.id;
}

export function storyPermalinkPath(story: Pick<StoryElement, 'id' | 'topic_id'>): string {
  return `/story/${encodeURIComponent(storyPermalinkId(story))}`;
}

export function storyPermalinkUrl(
  story: Pick<StoryElement, 'id' | 'topic_id'>,
  origin: string = window.location.origin,
): string {
  return new URL(storyPermalinkPath(story), origin).toString();
}
